"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typedLocalStorage = _interopRequireDefault(require("../../utils/typedLocalStorage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet2(t, e); return _classApplyDescriptorSet(e, s, r), r; }
function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
/**
 * A utility to control the Lume Theme toggling
 */
var _canEnable = /*#__PURE__*/new WeakMap();
var _enabled = /*#__PURE__*/new WeakMap();
var _localStorageKey = /*#__PURE__*/new WeakMap();
var _attributeName = /*#__PURE__*/new WeakMap();
var _attributeValue = /*#__PURE__*/new WeakMap();
var _enable = /*#__PURE__*/new WeakSet();
var _disable = /*#__PURE__*/new WeakSet();
var _toggle = /*#__PURE__*/new WeakSet();
var LumeThemeService = exports["default"] = /*#__PURE__*/function () {
  /**
   * Creates a new instance of this utility class passing the value whether toggling
   * can be enabled or not.
   *
   * @param {boolean} canEnable Whether the theme can be enabled.
   */
  function LumeThemeService(canEnable) {
    _classCallCheck(this, LumeThemeService);
    /**
     * Calls the #enable or #disable methods based on the #enabled value
     */
    _classPrivateMethodInitSpec(this, _toggle);
    /**
     * Disables the theme by removing the data attribute from the body element.
     */
    _classPrivateMethodInitSpec(this, _disable);
    /**
     * Enables the theme by setting a data attribute to the body element.
     */
    _classPrivateMethodInitSpec(this, _enable);
    _classPrivateFieldInitSpec(this, _canEnable, {
      writable: true,
      value: false
    });
    _classPrivateFieldInitSpec(this, _enabled, {
      writable: true,
      value: false
    });
    _classPrivateFieldInitSpec(this, _localStorageKey, {
      writable: true,
      value: 'uxf-eng-apc-lume-theme-service-enabled'
    });
    _classPrivateFieldInitSpec(this, _attributeName, {
      writable: true,
      value: 'data-theme'
    });
    _classPrivateFieldInitSpec(this, _attributeValue, {
      writable: true,
      value: 'anypoint-components-lume-theme'
    });
    _classPrivateFieldSet(this, _canEnable, canEnable);
    _classPrivateFieldSet(this, _enabled, canEnable && _typedLocalStorage["default"].getObject(_classPrivateFieldGet(this, _localStorageKey)));
    _classPrivateMethodGet(this, _toggle, _toggle2).call(this);
  }

  /**
   * @returns Whether the theme can be enabled.
   */
  _createClass(LumeThemeService, [{
    key: "canEnable",
    value: function canEnable() {
      return _classPrivateFieldGet(this, _canEnable);
    }

    /**
     * @returns Label used in the profile menu for the toggle.
     */
  }, {
    key: "getLabel",
    value: function getLabel() {
      return "Turn Lume Theme ".concat(_classPrivateFieldGet(this, _enabled) ? 'off' : 'on');
    }

    /**
     * Toggles the theme on/off.
     * Doesn't do anything if #canEnable is false.
     */
  }, {
    key: "toggle",
    value: function toggle() {
      if (!_classPrivateFieldGet(this, _canEnable)) {
        return;
      }
      _classPrivateFieldSet(this, _enabled, !_classPrivateFieldGet(this, _enabled));
      _classPrivateMethodGet(this, _toggle, _toggle2).call(this);
      _typedLocalStorage["default"].setObject(_classPrivateFieldGet(this, _localStorageKey), _classPrivateFieldGet(this, _enabled));
    }
  }]);
  return LumeThemeService;
}();
function _enable2() {
  document.body.setAttribute(_classPrivateFieldGet(this, _attributeName), _classPrivateFieldGet(this, _attributeValue));
}
function _disable2() {
  document.body.removeAttribute(_classPrivateFieldGet(this, _attributeName));
}
function _toggle2() {
  if (_classPrivateFieldGet(this, _enabled)) {
    _classPrivateMethodGet(this, _enable, _enable2).call(this);
  } else {
    _classPrivateMethodGet(this, _disable, _disable2).call(this);
  }
}
//# sourceMappingURL=LumeThemeService.js.map